module.exports = __webpack_public_path__ + "static/media/la-compagnie-robinson-nijXsx-oI7Y-unsplash.47c00c3d.jpg";